import { BaseSensorIconKeys } from '@assets/icons/sprite_icons/sensor/sencorIcon.types';
import { Center, Icon, IconProps, Text, VStack } from '@chakra-ui/react';
import { useDimensions } from '@hooks/useDimensions';
import { getSensorIconByKey } from '@utils/map/sensor.utils';
import { memo } from 'react';

interface Props extends IconProps {
  sensorIconName: BaseSensorIconKeys;
  size?: 'sm' | 'md' | 'lg';

  label?: string;
}

function getHeight(size: 'sm' | 'lg' | 'md'): string {
  switch (size) {
    case 'sm':
      return '48px';
    case 'md':
      return '54px';
    case 'lg':
      return '70px';
  }
}

function SensorIcon({ label, size = 'lg', sensorIconName }: Readonly<Props>) {
  const [dimensions, iconRef] = useDimensions();

  const IconComponent = getSensorIconByKey(sensorIconName, size);

  if (typeof IconComponent !== 'function' && typeof IconComponent !== 'object') {
    console.error(`getSensorIconByKey did not return a valid component for key "${sensorIconName}".`);
    return null;
  }

  return (
    <VStack alignItems="center" position="relative" gap={0}>
      <Center ref={iconRef}>
        <Icon as={IconComponent} width="auto" height={getHeight(size)} />
      </Center>
      {label && (
        <Text
          backgroundColor="neutral.black"
          padding={0.25}
          width={dimensions?.width}
          textOverflow="ellipsis"
          wordBreak="break-all"
          lineClamp={1}
          textAlign="center"
        >
          {label}
        </Text>
      )}
    </VStack>
  );
}

export default memo(SensorIcon);
